import React from 'react';
import { motion } from 'framer-motion';
import { ImageIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { initiatives } from '../data/about';
export function InitiativesShowcase() {
  return <Reveal className="mt-12" data-id="element-313" data-mp="3m62qzhjosd85">
      <div className="flex flex-col gap-2 sm:flex-row sm:items-end sm:justify-between" data-id="element-314" data-mp="3m6b49ajq1kjv">
        <h3 className="type-h3 text-primary" data-id="element-315" data-mp="3h4derykq9tih">Iniciativas que hemos impulsado</h3>
        <p className="text-sm font-semibold text-foreground/60" data-id="element-316" data-mp="3w25sqmamm9uk">
          <span className="font-display text-lg font-extrabold text-accent-gold" data-id="element-317" data-mp="3r4cm5s5evdtr">{initiatives.length}</span> iniciativas
          de impacto regional
        </p>
      </div>

      <ul className="mt-6 grid grid-cols-2 gap-x-4 gap-y-6 sm:grid-cols-3 md:gap-x-5 lg:grid-cols-5" data-id="element-318" data-mp="8s7pgc8dcscz">
        {initiatives.map((item, i) => <motion.li key={item.id} initial={{
        opacity: 0,
        y: 12
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-40px'
      }} transition={{
        duration: 0.45,
        delay: i % 5 * 0.05
      }} className="group flex flex-col" data-id="element-319" data-mp="inhuz9xz7hvi" data-mpi={i}>
            <motion.div whileHover={{
          y: -4
        }} className="flex aspect-[16/9] items-center justify-center overflow-hidden rounded-xl bg-white ring-1 ring-primary/10 transition-shadow group-hover:shadow-md" data-id="element-320" data-mp="3ke07tpk4m45i">
              {item.logo ? item.logoCover ? <img src={item.logo} alt={`Logo de ${item.name}`} loading="lazy" className="h-full w-full object-cover" data-id="element-321" data-mp="272mv4xqwq7v" /> : <img src={item.logo} alt={`Logo de ${item.name}`} loading="lazy" className="max-h-[78%] max-w-[82%] object-contain" data-id="element-322" data-mp="bxnluthbzwrb" /> : <div className="m-2 flex h-[calc(100%-1rem)] w-[calc(100%-1rem)] flex-col items-center justify-center gap-1 rounded-lg border-2 border-dashed border-primary/20 text-primary/45" data-id="element-323" data-mp="kw0n8kjndkb3">
                  <ImageIcon className="h-5 w-5" data-id="element-324" data-mp="2ly8hrf36fwqg" />
                  <span className="text-[10px] font-bold uppercase tracking-wider" data-id="element-325" data-mp="2hziw6z7zj8vq">Logo aquí</span>
                </div>}
            </motion.div>
            <h4 className="type-h5 mt-3 text-primary" data-id="element-326" data-mp="2vrz4ofjnnz41">{item.name}</h4>
          </motion.li>)}
      </ul>
    </Reveal>;
}